import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Setup Passkey Submitted event.
 */
export type SetupPasskeySubmittedProps = EventProps

/**
 * @event setup_passkey_submitted
 */
export const SetupPasskeySubmittedAnalytics = createAnalyticsStatic<SetupPasskeySubmittedProps>(
    ANALYTICS_EVENTS.PASSKEY.SETUP_SUBMITTED,
)

export default SetupPasskeySubmittedAnalytics
